import * as React from 'react';
import { useSelector } from 'react-redux';
import { getMortgageBannerUrl } from '../../selectors/discountMortgage/getMortgageBannerUrl';
import { DiscountMortgageBanner } from '../../components/DiscountMortgageBanner';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

export const DiscountMortgageBannerContainer = () => {
  const url = useSelector(getMortgageBannerUrl);
  // TODO добавить аналитику CD-206060
  const onBannerShown = React.useCallback(() => {}, []);
  const onBannerClick = React.useCallback(() => {}, []);

  return (
    <ActionAfterViewObserver callback={onBannerShown} triggerOnce>
      <DiscountMortgageBanner url={url} onClick={onBannerClick} />
    </ActionAfterViewObserver>
  );
};
